import { DashboardUserDateDisplay } from '@moniebook-web/components/widgets/dashboard-user-date-display';
import type { AppSubmodule } from '@moniebook-web/components/widgets/sidebar/types';
import clsx from 'clsx';
import { NavLink } from 'react-router';

import type { SidebarMenuGroup } from './types';

interface SubmenuPanelProps {
    group: SidebarMenuGroup;
}

export function SubmenuPanel({ group }: Readonly<SubmenuPanelProps>) {
    return (
        <div className='flex flex-grow flex-col bg-background-sidebar-faded2'>
            <div className='flex h-40 w-full items-center px-16'>
                <span className='truncate font-medium text-12 text-new-neutral-600 tracking-wide'>
                    {group.name}
                </span>
            </div>
            <div className='flex flex-grow flex-col gap-1 px-8'>
                {group.children?.map((item) => (
                    <SubmenuItem key={item.name} item={item} />
                ))}
            </div>
            <div className='flex desktop:hidden h-48 items-center justify-center'>
                <DashboardUserDateDisplay />
            </div>
        </div>
    );
}

interface SubmenuItemProps {
    item: AppSubmodule;
}

function SubmenuItem({ item }: Readonly<SubmenuItemProps>) {
    return (
        <NavLink
            to={item.to}
            className={({ isActive, isPending }) =>
                clsx(
                    'flex h-40 w-full items-center gap-8 rounded-4 px-8 text-14 transition-colors duration-200 md:h-32',
                    isActive || isPending
                        ? 'bg-new-blue-100 font-medium text-new-blue-700'
                        : 'font-normal text-new-neutral-600 hover:bg-background-inset-default hover:text-new-neutral-1000',
                )
            }>
            {({ isActive, isPending }) => (
                <>
                    {item.icon && (
                        <div
                            className={clsx(
                                'shrink-0',
                                isActive || isPending
                                    ? 'text-new-blue-700'
                                    : 'text-new-neutral-700',
                            )}>
                            {item.icon}
                        </div>
                    )}
                    <span className='truncate'>{item.name}</span>
                </>
            )}
        </NavLink>
    );
}
